import { useRef } from 'react'
import { Select, Checkbox, Input } from 'antd'
import { useStore } from 'react-redux'
import './style.less'

export function judgeAddressSettingError(list) {
  if (!Array.isArray(list)) {
    return ''
  }
  if (list.length === 0) {
    return ''
  }
  let error = ''
  const errorList = ['请设定国家', '请设定省', '请设定城市', '请设定区']
  const prevObj = { show: list[0].show, value: list[0].value, index: 0 }
  for (let i = 1, len = list.length - 1; i < len; i++) {
    if ((list[i].show || (!list[1].show && list[1].value)) && !prevObj.show && !prevObj.value) {
      error = errorList[prevObj.index]
      break
    }
    prevObj.show = list[i].show
    prevObj.value = list[i].value
    prevObj.index = i
  }
  return error
}

const Cpcd = ({ setting, value, onChange, ...rest }) => {
  const store = useStore()
  const prefixCls = 'bytfc-cpcd'
  const info = localStorage.getItem(store.getState().cpcdKey)
  const language = store.getState().language
  let list = []
  const { disabled } = rest

  try {
    list = JSON.parse(info)
  } catch (error) {}

  if (!Array.isArray(list)) {
    list = []
  }

  const error = judgeAddressSettingError(value)

  const findChildren = (list, pId) => {
    if (!pId) {
      return []
    }
    for (let i = 0, len = list.length; i < len; i++) {
      const item = list[i]
      const childrens = 'children' in item && Array.isArray(item.children) ? item.children : []
      if (item.value === pId) {
        return childrens.map(c => {
          const label = language === 'en-US' ? c.labelEn : c.label
          return { label: label, value: c.value }
        })
      }
      if (childrens.length > 0) {
        const ret = findChildren(childrens, pId)
        if (ret.length) {
          return ret
        }
      }
    }
    return []
  }
  const countryOptions = []
  for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i]
    countryOptions.push({
      label: language === 'en-US' ? item.labelEn : item.label,
      value: item.value
    })
  }
  let provinceOptions = []
  let cityOptions = []
  let regionOptions = []

  let dCountry = undefined
  let dCbCountry = false
  let dProvince = undefined
  let dCbProvince = false
  let dCity = undefined
  let dCbCity = false
  let dRegion = undefined
  let dCbRegion = false
  let dAddress = ''
  let dCbAddress = false

  let showCountry = false
  let showProvince = false
  let showCity = false
  let showRegion = false
  let showAddrenss = false

  const rowShow = (item, len) => {
    if (setting) {
      return true
    }
    if (!len) {
      return false
    }
    return !item.show && item.value ? false : item.show
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      const v = item.value || undefined
      if (index === 0) {
        dCountry = v
        dCbCountry = item.show
        showCountry = rowShow(item, countryOptions.length)
      } else if (index === 1) {
        dProvince = v
        dCbProvince = item.show
        provinceOptions = findChildren(list, dCountry)
        showProvince = rowShow(item, provinceOptions.length)
      } else if (index === 2) {
        dCity = v
        dCbCity = item.show
        cityOptions = findChildren(list, dProvince)
        showCity = rowShow(item, cityOptions.length)
      } else if (index === 3) {
        dRegion = v
        dCbRegion = item.show
        regionOptions = findChildren(list, dCity)
        showRegion = rowShow(item, regionOptions.length)
      } else if (index === 4) {
        dAddress = item.value
        dCbAddress = item.show
        showAddrenss = rowShow(item, 1)
      }
    })
  }

  function changeHandler(index, type, value) {
    if (typeof onChange !== 'function') {
      return
    }
    onChange(index, type, value)
  }

  function inputChangeHandler(event) {
    if (event.type === 'compositionstart') {
      return
    }
    const v = event.target.value.trim()
    changeHandler(4, 'input', v)
  }

  const selectProps = {
    allowClear: true,
    labelInValue: true
  }
  const cpcdRef = useRef()

  return (
    <div className={prefixCls} ref={cpcdRef}>
      {setting && error && <div className={`${prefixCls}-error`}>{error}</div>}
      {showCountry && (
        <div className={`${prefixCls}-item`}>
          {setting && (
            <Checkbox
              checked={dCbCountry}
              className={`${prefixCls}-cbx`}
              onChange={event => {
                const value = event.target.checked
                changeHandler(0, 'cb', value)
              }}
            />
          )}
          <Select
            className={`${prefixCls}-select`}
            value={dCountry}
            disabled={disabled}
            options={countryOptions}
            {...selectProps}
            getPopupContainer={() => cpcdRef.current}
            placeholder={language === 'en-US' ? 'Please select country/region' : '请选择国家/地区'}
            onChange={value => {
              changeHandler(0, 'sl', value)
              changeHandler(1, 'sl', '')
              changeHandler(2, 'sl', '')
              changeHandler(3, 'sl', '')
            }}></Select>
        </div>
      )}
      {showProvince && (
        <div className={`${prefixCls}-item`}>
          {setting && (
            <Checkbox
              checked={dCbProvince}
              className={`${prefixCls}-cbx`}
              onChange={event => {
                const value = event.target.checked
                changeHandler(1, 'cb', value)
              }}
            />
          )}
          <Select
            value={dProvince}
            className={`${prefixCls}-select`}
            {...selectProps}
            disabled={disabled}
            options={provinceOptions}
            getPopupContainer={() => cpcdRef.current}
            placeholder={language === 'en-US' ? 'Please select state/province' : '请选择州/省'}
            onChange={value => {
              changeHandler(1, 'sl', value)
              changeHandler(2, 'sl', '')
              changeHandler(3, 'sl', '')
            }}></Select>
        </div>
      )}
      {showCity && (
        <div className={`${prefixCls}-item`}>
          {setting && (
            <Checkbox
              checked={dCbCity}
              className={`${prefixCls}-cbx`}
              onChange={event => {
                const value = event.target.checked
                changeHandler(2, 'cb', value)
              }}
            />
          )}
          <Select
            value={dCity}
            className={`${prefixCls}-select`}
            {...selectProps}
            disabled={disabled}
            options={cityOptions}
            getPopupContainer={() => cpcdRef.current}
            placeholder={language === 'en-US' ? 'Please select city' : '请选择市'}
            onChange={value => {
              changeHandler(2, 'sl', value)
              changeHandler(3, 'sl', '')
            }}></Select>
        </div>
      )}
      {showRegion && (
        <div className={`${prefixCls}-item`}>
          {setting && (
            <Checkbox
              checked={dCbRegion}
              className={`${prefixCls}-cbx`}
              onChange={event => {
                const value = event.target.checked
                changeHandler(3, 'cb', value)
              }}
            />
          )}
          <Select
            className={`${prefixCls}-select`}
            value={dRegion}
            {...selectProps}
            disabled={disabled}
            options={regionOptions}
            getPopupContainer={() => cpcdRef.current}
            placeholder={language === 'en-US' ? 'Please select district' : '请选择区'}
            onChange={value => {
              changeHandler(3, 'sl', value)
            }}></Select>
        </div>
      )}
      {showAddrenss && (
        <div className={`${prefixCls}-item`}>
          {setting && (
            <Checkbox
              checked={dCbAddress}
              className={`${prefixCls}-cbx`}
              onChange={event => {
                const value = event.target.checked
                changeHandler(4, 'cb', value)
              }}
            />
          )}
          <Input
            value={dAddress}
            placeholder={language === 'en-US' ? 'Please enter address' : '请输入详细地址'}
            maxLength={200}
            disabled={disabled}
            onChange={inputChangeHandler}
            onCompositionStart={inputChangeHandler}
            onCompositionEnd={inputChangeHandler}
          />
        </div>
      )}
    </div>
  )
}

export default Cpcd
